module.exports = __webpack_public_path__ + "img/404.f15a6dd8.svg";